import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { RoutesExtensionInterface } from '../../../extension/interface/routes.extension.interface';
import { TranslationExtensionInterface } from '../../../extension/interface/translation.extension.interface';
import { BikeleasingBenefitListItemExtension } from './bikeleasing-benefit-list-item.extension';
import { BikeleasingBenefitMetadataExtension } from './bikeleasing-benefit-metadata.extension';
import { BikeleasingBenefitTranslationExtension } from './bikeleasing-benefit-translation.extension';
import { BikeleasingRoutesExtension } from './bikeleasing-routes.extension';
import { BikeleasingTranslationExtension } from './bikeleasing-translation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bikeleasing_v2')
    .add(BenefitMetadataExtensionInterface, new BikeleasingBenefitMetadataExtension())
    .add(RoutesExtensionInterface, new BikeleasingRoutesExtension())
    .add(TranslationExtensionInterface, new BikeleasingTranslationExtension())
    .add(BenefitListItemExtensionInterface, new BikeleasingBenefitListItemExtension())
    .build(),
);

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bikeleasing_v2_benefit').add(TranslationExtensionInterface, new BikeleasingBenefitTranslationExtension()).build(),
);
